
export class ITranslatable {}

